import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { focalPosition } from '../../lib/photoFocal';

export function VaultTab({ memorialId }) {
  const [media, setMedia] = useState([]);
  useEffect(() => {
    api.get(`/memorials/${memorialId}/media?visibility=vault`).then(({ data }) => setMedia(data.media));
  }, [memorialId]);
  return (
    <div className="space-y-5">
      <div className="ml-card">
        <h2 className="font-serif text-2xl text-[hsl(var(--primary))]">Family Vault</h2>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">Photos, videos, and memories reserved for approved family.</p>
      </div>
      {media.length === 0 ? (
        <div className="ml-card text-sm text-[hsl(var(--muted-foreground))]">No vault memories yet. Use the Memories tab to upload with visibility "vault".</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {media.map((m) => {
            const url = m.external_url || `${process.env.REACT_APP_BACKEND_URL}/api/media/${m.media_id}/file`;
            return (
              <div key={m.media_id} className="relative aspect-square rounded-xl overflow-hidden bg-[hsl(var(--muted))]">
                <img src={url} alt="" className="w-full h-full object-cover" style={{ objectPosition: focalPosition(m) }} />
                {m.caption && <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[hsl(var(--primary))]/80 to-transparent text-[#FDFBF7] text-xs p-2">{m.caption}</div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
